module.exports = __webpack_public_path__ + "static/img/thumb-01.490624f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/flash/thumb/thumb-01.png
// module id = 4hv2
// module chunks = 150